exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-footer{background: #FFF;}.page-login-v3 .panel{width: 100%}.page-content,.panel-body{padding:30px 10px}.panel-body{position:relative}.panel-title{display:block;margin-top:0;margin-bottom:0;padding:20px 10px;font-size:18px;color:#37474f}.in{opacity:1!important}.modal-backdrop.fade{opacity:.5!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!G:/3csoft/client-final/node_modules/postcss-loader?{"ident":"postcss"}!G:/3csoft/client-final/src/assets/evs/css/style.min.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/evs/css/style.min.css
// module chunks = styles